/** When true, Jain Gaurav Yatra is served at the site root (`/admin/login`, `/app`, …) with no `/:tenantId/jaingauravyatra` prefix. */
export const JGY_EMBEDDED_AT_ROOT =
  import.meta.env.VITE_JGY_EMBEDDED === "true";

/** Tenant id for `X-Tenant-Id` / context when using root URLs; override with `VITE_X_TENANTID` in `.env`. */
export const JGY_STATIC_TENANT_ID: string =
  (typeof import.meta.env.VITE_X_TENANTID === "string" &&
    import.meta.env.VITE_X_TENANTID.trim()) ||
  "0055a599-8349-4cc7-b08c-f50cfa23b834";
